import he from 'he';
import fp from 'lodash/fp';
import { searchTileType, cpdCategoryType } from '../constants';
import placeholderImage from '../images/placeholders/card03.png';
import { findCpdCategory } from './areas-of-advice';
import { findPublisher } from './publisher';

export const filterRecommendedByCpdCategory = (cpdCategoryId) =>
  fp.flow(
    fp.filter(r => r.cpdCategoryId === cpdCategoryId),
    fp.map(r => r.eventQueryResult.events),
    fp.flatten
  );

export const mapRecommendedEvents = (cpdCategorys, publishers) =>
  fp.flow(
    fp.map((event) => {
      const eventCoreCpdPoints = fp.flow(
        fp.filter(
          ({ cpdCategoryId }) => fp.find(
            ({ id, categoryType }) => id === cpdCategoryId && categoryType === cpdCategoryType.core
          )(cpdCategorys)
        ),
        fp.sumBy('points')
      )(event.cpdCategorys);

      return ({
      ...event,
      points: eventCoreCpdPoints,
      publisher: publishers ?
        findPublisher(event.publisherId)(publishers) :
        null
      })
    }),
    fp.map((event) => ({
      type: searchTileType.Event,
      id: event.id,
      fullCpdCategory: fp.map(
        ({ cpdCategoryId, cpdPoints  }) => {
          const cpdCategoryFound = findCpdCategory(cpdCategoryId)(cpdCategorys)
          return {
            cpdCategoryId,
            name: cpdCategoryFound ? he.decode(cpdCategoryFound.name) : 'None',
            points: cpdPoints,
            categoryType: cpdCategoryFound.categoryType
          }
        }
      )(event.cpdCategorys),
      category: (cpdCategorys && cpdCategorys.length > 0) ?
        event.cpdCategorys.length === 0 ? 'None' :
          event.cpdCategorys.length > 1 ? 'Multiple' :
            he.decode(findCpdCategory(fp.first(event.cpdCategorys).cpdCategoryId)(cpdCategorys) ? findCpdCategory(fp.first(event.cpdCategorys).cpdCategoryId)(cpdCategorys).name : 'None') :
        null,
      altText: event.title ? he.decode(event.title) : 'Unknown',
      title: event.title ? he.decode(event.title) : 'Unknown',
      description: event.description ? he.decode(event.description) : 'Unknown',
      publisher: event.publisher ? he.decode(event.publisher.name) : 'Unknown',
      cpdPoints: event.points,
      duration: `${event.durationDay ? `${event.durationDay} d ` : ''}${event.durationMinute ? `${Math.floor(event.durationMinute / 60)} h` : ''}${event.durationMinute ? `${event.durationMinute % 60} m` : ''}`,
      image: event.previewImageUrl ? he.decode(event.previewImageUrl) : placeholderImage,
      venue: event.location,
      suburb: event.suburb,
      date: event.dateTimeOfEvent,
      price: event.price,
      externalCpdRecordsForUser: event.externalCpdRecordsForUser,
      isTasaCpd: event.isTasaCpd,
      completionStatus: event.userEventCompletionStatus,
      status: event.status,
      searchTileId: event.searchTileId,
      goals: event.goals,
      ignoreStartTime: event.ignoreStartTime,
      ignoreDuration: event.ignoreDuration
    }))
  )

export const mapRecommendedCourses = (cpdCategorys, publishers) =>
  fp.flow(
    fp.map((event) => {
      const eventCoreCpdPoints = fp.flow(
        fp.filter(
          ({ cpdCategoryId }) => fp.find(
            ({ id, categoryType }) => id === cpdCategoryId && categoryType === cpdCategoryType.core
          )(cpdCategorys)
        ),
        fp.sumBy('points')
      )(event.cpdCategorys);

      return ({
      ...event,
      points: eventCoreCpdPoints,
      publisher: publishers ?
        findPublisher(event.publisherId)(publishers) :
        null
      })
    }),
    fp.map((event) => ({
      type: searchTileType.Course,
      id: event.id,
      fullCpdCategory: fp.map(
        ({ cpdCategoryId  }) => {
          const cpdCategoryFound = findCpdCategory(cpdCategoryId)(cpdCategorys)
          return {
            cpdCategoryId,
            name: cpdCategoryFound ? he.decode(cpdCategoryFound.name) : 'None',
            categoryType: cpdCategoryFound.categoryType
          }
        }
      )(event.cpdCategorys),
      category: (cpdCategorys && cpdCategorys.length > 0) ?
        event.cpdCategorys.length === 0 ? 'None' :
          event.cpdCategorys.length > 1 ? 'Multiple' :
            he.decode(findCpdCategory(fp.first(event.cpdCategorys).cpdCategoryId)(cpdCategorys) ? findCpdCategory(fp.first(event.cpdCategorys).cpdCategoryId)(cpdCategorys).name : 'None') :
        null,
      altText: event.title ? he.decode(event.title) : 'Unknown',
      title: event.title ? he.decode(event.title) : 'Unknown',
      publisher: event.publisher ? he.decode(event.publisher.name) : 'Unknown',
      cpdPoints: event.points,
      duration: `${event.durationDay ? `${event.durationDay} d ` : ''}${event.durationMinute ? `${Math.floor(event.durationMinute / 60)} h` : ''}${event.durationMinute ? `${event.durationMinute % 60} m` : ''}`,
      image: event.previewImageUrl ? he.decode(event.previewImageUrl) : placeholderImage,
      venue: event.location,
      suburb: event.suburb,
      date: event.dateTimeOfEvent,
      price: event.price,
      externalCpdRecordsForUser: event.externalCpdRecordsForUser,
      isTasaCpd: event.isTasaCpd,
      completionStatus: event.userEventCompletionStatus,
      status: event.status,
      searchTileId: event.searchTileId,
      goals: event.goals
    }))
  )



// WEBPACK FOOTER //
// ./src/services/event.js